import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import {
  FDPaper,
} from '@facet-wealth/design';
import ListDetailView from 'Components/ComponentLibrary/Organisms/ListDetailView';
import { noop } from 'Helpers/PropTypes';
import { dataAttrs } from 'Helpers/Testing';

export default function FacetPlanNextUpScenarioReviewLayout({
  resource,
  setActiveTabResourceType,
}) {
  const link = resource.withRelationship(fr.relationships.listItems.name,
    (rel) => rel.link('related'),
    () => null);

  if (link === null) {
    return null;
  }

  return (
    <FDPaper
      appearance={'elevated'}
      height={'100%'}
      maxHeight={'100%'}
      width={'100%'}
      padding={200}
      {...dataAttrs('next-up-preview-layout-paper')}
    >
      <ListDetailView listCollectionSelfLink={link} setActiveTabResourceType={setActiveTabResourceType} />
    </FDPaper>
  );
}

FacetPlanNextUpScenarioReviewLayout.defaultProps = {
  setActiveTabResourceType: noop,
};

FacetPlanNextUpScenarioReviewLayout.propTypes = {
  resource: PropTypes.object.isRequired,
  setActiveTabResourceType: PropTypes.func,
};
